module.exports = __webpack_public_path__ + "img/svg/twitter.7aa781700077d01773b40401b6302864.svg";